import {Feature} from './feature.class';

export class RoleFeature {
    role_key: string;
    feature_key: string;
    user_field: string;
    created_at: Date;
    updated_at: Date;
    feature: Feature;
}
